import { FormControl, FormField, FormItem, FormLabel } from "../ui/form";
import StarIcon from "../../assets/svgs/common/star.svg";
import type { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Button } from "../ui/button";
import { Calendar } from "../ui/calendar";
import { cn } from "../../utils/utils";
import { format } from "date-fns";
import CalendarIcon from "../../assets/svgs/common/calander.svg";
import type { DayPickerSingleProps } from "react-day-picker";

type FormDateInputProps<T extends FieldValues> = {
	form: UseFormReturn<T>;
	name: Path<T>;
	label: string;
	placeholder: string;
	required?: boolean;
	disabledDays?: DayPickerSingleProps["disabled"];
};

export const FormDateInput = <T extends FieldValues>({
	form,
	name,
	label,
	placeholder,
	required,
	disabledDays,
}: FormDateInputProps<T>) => {
	return (
		<FormField
			control={form.control}
			name={name}
			render={({ field }) => (
				<FormItem className="flex flex-col">
					<FormLabel className="flex items-center gap-1 font-semibold">
						{label} {required && <StarIcon />}
					</FormLabel>
					<Popover>
						<PopoverTrigger asChild>
							<FormControl>
								<Button
									className={cn(
										"py-2 h-16 rounded-xl w-full flex items-center justify-between font-semibold bg-bginput text-primary border border-border",
										!field.value && "text-secondary",
									)}
								>
									{field.value ? (
										format(field.value, "PPP")
									) : (
										<span>{placeholder}</span>
									)}
									<CalendarIcon />
								</Button>
							</FormControl>
						</PopoverTrigger>
						<PopoverContent
							className="border-0 p-0 rounded-xl w-auto"
							align="start"
						>
							{/* <PopoverClose> */}
								<Calendar
									mode="single"
									selected={field.value}
									onSelect={field.onChange}
									disabled={disabledDays}
									className="bg-background border border-border rounded-lg"
								/>
							{/* </PopoverClose> */}
						</PopoverContent>
					</Popover>
				</FormItem>
			)}
		/>
	);
};
